import { APP_NEW_CONST, SaturedVaporPressure } from "../constants/newConst";
import { PoolInfo, PoolLocation } from "../context/types";

export const calculateSurfaceHeatLoss = ({
  poolInfo,
  monthTemp,
  surfaceAreaTop,
}: {
  poolInfo: PoolInfo;
  monthTemp: number;
  surfaceAreaTop: number;
}) => {
  const vConstant = poolInfo.location === PoolLocation.OUTDOOR ? 2.5 : 0.3;
  const desireTemp = poolInfo.requirePoolTemp.toString();

  const truncMonthTemp = Math.floor(monthTemp);
  const A = surfaceAreaTop;
  const PB = SaturedVaporPressure[desireTemp];

  const Pq = SaturedVaporPressure[truncMonthTemp];

  const heatSurfaceLost =
    APP_NEW_CONST["1/B"] *
    APP_NEW_CONST.Y *
    (0.0174 * vConstant + 0.0229) *
    (PB - Pq) *
    A *
    (APP_NEW_CONST["B/B"] / 3600);
  return heatSurfaceLost;
};
